import DisabledNodesParentTreeNode from "./DisabledNodesParentTreeNode";
import TreeNode from "./TreeNode";

export default class ArchivedProjectsParentTreeNode extends DisabledNodesParentTreeNode {
    constructor(parentId) {
        super("ap", parentId);
    }

    getType() {
        return TreeNode.TYPE_ARCHIVED_PROJECTS_PARENT
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/ArchivedProjectsParentTreeNode.js